.box {
  overflow-y: auto;
}
